/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Create_SuccessInputs */

const en_admin_invite_codes_create_success = /** @type {(inputs: Admin_Invite_Codes_Create_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code(s) created`)
};

/**
* | output |
* | --- |
* | "Invite code(s) created" |
*
* @param {Admin_Invite_Codes_Create_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_create_success = /** @type {((inputs?: Admin_Invite_Codes_Create_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Create_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_create_success(inputs)
});
export { admin_invite_codes_create_success as "admin.invite_codes.create_success" }